import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS, Permission } from '../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed =
      !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.ALL_ACCOUNTS }) ||
      !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.ALL_ACCOUNTS, permission: Permission.UPDATE });
    context.validatePermissions({ isAllowed, preload });
  },
});
